import React, { useEffect } from 'react'

import CTA from '@f/elements/CTA'
import FormCheckbox from '@f/elements/FormCheckbox'
import FormWrapper from '@f/elements/FormWrapper'

const policyOptions = {
  essentials: 'es',
  statistic: 'st',
  functional: 'fu',
  marketing: 'ma'
}

const options = [
  {
    value: policyOptions.essentials,
    label: 'Notwendig',
    checked: true,
    description:
      'Erforderliche Cookies tragen dazu bei, dass sich die User auf der Website bewegen können, indem grundlegende Einrichtungen wie das Navigieren auf den Seiten und der Zugang zu sicheren Bereichen gewährleistet sind. Ohne diese Cookies würde die Website nicht zweckmäßig funktionieren',
    disabled: true
  },
  {
    value: policyOptions.statistic,
    label: 'Statistik',
    checked: false,
    description:
      'Statistische Cookies ermöglichen es uns,unser Angebot und unsere Webseite weiter zu verbessern, erfassen wir anonymisierte Daten für Statistiken und Analysen. Mithilfe dieser Cookies können wir beispielsweise die Besucherzahlen und den Effekt bestimmter Seiten unseres Web-Auftritts ermitteln und unsere Inhalte optimieren.'
  },
  {
    value: policyOptions.functional,
    label: 'Funktional',
    checked: false,
    description:
      'Funktionale Cookies ermöglichen es, Informationen zu speichern, die das Erscheinungsbild oder die Handlungen auf der Website ändern können. Dabei könnte es sich um Ihre bevorzugte Sprache oder Region handeln.'
  },
  {
    value: policyOptions.marketing,
    label: 'Marketing',
    checked: false,
    description:
      'Marketing-Cookies werden genutzt, um Besucher über verschiedene Websites zu identifizieren. Ziel und Zweck ist es, den einzelnen Webnutzern Werbung zu zeigen, die für sie relevant und interessant ist, und damit wertvoller für Herausgeber und Drittinserenten.'
  }
]

const CookieModal = props => {
  const COOKIEPOLICYCONFIG = 'cookie_policy_config'

  const saveAll = () => {
    _wt({
      category: 'form',
      action: 'submit',
      values: [
        {
          type: 'cookie',
          value: 'es,st,fu,ma'
        }
      ],
      location: 'modal-cookies'
    })

    window['🍪'].set(
      COOKIEPOLICYCONFIG,
      Object.values(policyOptions).join(','),
      3650
    )

    window.loadGtm?.()

    props.closeModal()
  }

  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'cookies'
        }
      ]
    })
  }, [])

  const handleSubmit = ({ elements }) => {
    const values = elements.reduce((prev, curr) => {
      if (curr.value) {
        prev.push(curr.name.replace('cookie-', ''))
      }

      return prev
    }, [])

    _wt({
      category: 'form',
      action: 'submit',
      values: [
        {
          type: 'cookie',
          value: values.join(',')
        }
      ],
      location: 'modal-cookies'
    })

    window['🍪'].set(COOKIEPOLICYCONFIG, values.join(','), 3650)
    if (values.includes(policyOptions.statistic)) {
      window.loadGtm?.()
    }
    setTimeout(() => props.closeModal(), 100)
  }

  return (
    <div className='CookieModal-wrapper'>
      <div className='[ f-d-flc f-c-ba-bac025 f-m-h-010 f-p-v-030 f-p-h-020 f-radius-card-large ]'>
        <div className='[ f-t-tminor f-t-bold f-p-b-010 ]'>
          Cookie-Einstellungen
        </div>
        <FormWrapper
          className='[ f-d-flc ] Cookie-Banner-form'
          onSuccess={handleSubmit}
          wtDisable>
          {options.map(option => (
            <FormCheckbox
              formElement
              theme='form'
              name={`cookie-${option.value}`}
              key={`cookie-${option.value}`}
              defaultChecked={option.checked}
              toggledDescription={option.description}
              checkboxValue={option.value}
              label={option.label}
              labelClassNames='[ f-t-tbody f-t-bold f-p-l-005 ]'
              descriptionClassNames='[ f-d-bl f-t-micro ] CookieModal-details'
              className='[ f-d-inbl f-p-b-020 ] CookieModal-item'
              inputProps={{
                disabled: option.disabled
              }}
              wtData={{
                valueOverride: option.value,
                checkbox: {
                  location: 'modal-cookies'
                }
              }}
            />
          ))}
          <div className='[ f-d-flr f-fl-wrap f-m-t-020 ] CookieModal-CTA-wrapper'>
            <CTA
              type='text-primary'
              tag='button'
              buttonType='submit'
              className='[ f-t-body f-m-t-010 ] is-block:s'
              wtData={{
                'CTA-click': {
                  location: 'modal-cookies'
                }
              }}>
              Einstellungen speichern
            </CTA>
            <CTA
              type='block-primary'
              tag='button'
              className='[ f-m-t-010 f-m-l-020:m ] is-block:s'
              onClick={saveAll}
              wtData={{
                'CTA-click': {
                  location: 'modal-cookies'
                }
              }}>
              Alle akzeptieren
            </CTA>
          </div>
        </FormWrapper>
      </div>
    </div>
  )
}

export default CookieModal
